import React, {FC, useCallback} from "react"
import {formatTextTestIds} from "@next/utils"
import {ColourChipListItem, ColourChipLink} from "./components"
import {isTouchDevice as getIsTouchDevice} from "../../../../utils/is-touch-device"
import {handleProductClick} from "../../../../events"

interface ColourChipProps {
    linkUrl: string
    isSelected: boolean
    setMatchingColourWay: (itemNumber: string, index: number) => void
    itemNumber: string
    src: string
    className?: string
    dataSrc?: string
    id: string
    title: string
    price: string
    colour: string
    currencyCode: string
    department: string
    altText: string
    firstItemNumber: string
    brand: string
    client: string
    slideIndex: (index: number) => void
    index: number
}

export const StandardColourChip: FC<ColourChipProps> = ({
    linkUrl,
    isSelected,
    setMatchingColourWay,
    itemNumber,
    src,
    className,
    dataSrc,
    id,
    title,
    price,
    colour,
    currencyCode,
    department,
    altText,
    firstItemNumber,
    brand,
    client,
    slideIndex,
    index,
}) => {
    const isTouchDevice = getIsTouchDevice()

    const handleOnClick = useCallback(
        (e: React.MouseEvent) => {
            if (isTouchDevice && !isSelected) {
                setMatchingColourWay(itemNumber, index)
                slideIndex(index)
                e.preventDefault()
            } else {
                handleProductClick({id, title, price, colour, currencyCode, department, firstItemNumber, brand, client})
            }
        },
        [
            isTouchDevice,
            isSelected,
            setMatchingColourWay,
            itemNumber,
            index,
            slideIndex,
            id,
            title,
            price,
            colour,
            currencyCode,
            department,
            firstItemNumber,
            brand,
            client,
        ],
    )

    const onSetMatchingColourWay = useCallback(() => {
        if (!isSelected) {
            setMatchingColourWay(itemNumber, index)
            slideIndex(index)
        }
    }, [isSelected, setMatchingColourWay, itemNumber, index, slideIndex])

    return (
        <ColourChipListItem
            className={isSelected ? "selected" : ""}
            onFocus={onSetMatchingColourWay}
            aria-current={isSelected ? "true" : "false"}
        >
            <ColourChipLink title={colour} onClick={handleOnClick} href={linkUrl}>
                {isTouchDevice ? (
                    <img
                        src={src}
                        className={className}
                        data-src={dataSrc}
                        data-testid={formatTextTestIds(`product_summary_colourchip_${itemNumber}`)}
                        alt={altText}
                        onMouseEnter={onSetMatchingColourWay}
                    />
                ) : (
                    <img
                        src={src}
                        className={className}
                        data-src={dataSrc}
                        onMouseOver={onSetMatchingColourWay}
                        onFocus={onSetMatchingColourWay}
                        data-testid={formatTextTestIds(`product_summary_colourchip_${itemNumber}`)}
                        alt={altText}
                    />
                )}
            </ColourChipLink>
        </ColourChipListItem>
    )
}

export default StandardColourChip
